import { render } from "./MemberApplicationDetail.vue?vue&type=template&id=0c572f77&scoped=true"
import script from "./MemberApplicationDetail.vue?vue&type=script&lang=js"
export * from "./MemberApplicationDetail.vue?vue&type=script&lang=js"

import "./MemberApplicationDetail.vue?vue&type=style&index=0&id=0c572f77&lang=css"
import "./MemberApplicationDetail.vue?vue&type=style&index=1&id=0c572f77&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c572f77"]])

export default __exports__